import handleGa, { getButtonData } from './handle-ga';

const handleChat = (content = '', arg1, arg2) => {
  let token = null;
  let event = [];

  if (Array.isArray(arg1)) {
    event = arg1;
  } else if (Array.isArray(arg2)) {
    token = arg1;
    event = arg2;
  }

  window._MEIQIA('showPanel', {
    greeting: content
  });

  const action = event[1] === 'type1' ? '立即购买' : '免费试用';
  handleGa(action, getButtonData(event[0]));
};

export const sendNumber = number => {
  window._MEIQIA('metadata', {
    tel: number
  });
};

export default handleChat;
